const convertBtcUnit = (amount: number, isUbtcEnabled = false) => {
  if (isUbtcEnabled) {
    return amount * 1_000_000;
  }
  return amount * 1_000;
};

export default convertBtcUnit;
